import React, { useState } from "react";
import { Card, Button, ButtonGroup, Modal, Carousel } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { IoIosAppstore } from "react-icons/io";
import { Link } from "react-router-dom";
import screenshot1 from "../../Assets/Projects/1to50/1to50_store_01.png";
import screenshot2 from "../../Assets/Projects/1to50/1to50_store_02.png";
import screenshot3 from "../../Assets/Projects/1to50/1to50_store_03.png";
import screenshot4 from "../../Assets/Projects/1to50/1to50_store_04.png";
import screenshot5 from "../../Assets/Projects/1to50/1to50_store_05.png";
import screenshot6 from "../../Assets/Projects/1to50/1to50_store_06.png";
import screenshot7 from "../../Assets/Projects/1to50/1to50_store_07.png";

const translations = {
  tr: {
    title: "1to50 Race",
    description: "5x5'lik bir tahtada 1'den 50'ye karışık verilen sayıları mümkün olduğunca hızlı eritme temalı bir iOS oyunu. Basit ama bağımlılık yapıcı! En hızlı sürenizi kırın ve kendinizi zorlayın.",
    details: "Detaylar",
    privacy: "Gizlilik Politikası",
    terms: "Kullanım Şartları",
    modalTitle: "1to50 Race - Detaylı Bilgi",
    features: [
      "🔢 Basit Oynanış: 1'den 50'ye sırayla dokun",
      "⏱️ Zaman Yarışı: En hızlı sürenizi kırmaya çalışın",
      "🏆 Skor Takibi: En iyi sürenizi kaydedin",
      "🎯 Kolay öğren, ustalaşması zor",
      "📱 Swift & UIKit ile geliştirildi"
    ]
  },
  en: {
    title: "1to50 Race",
    description: "An iOS game where you tap numbers from 1 to 50 on a 5x5 board as fast as possible. Simple but addictive! Beat your fastest time and challenge yourself.",
    details: "Details",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    modalTitle: "1to50 Race - Detailed Information",
    features: [
      "🔢 Simple Gameplay: Tap numbers 1 to 50 in order",
      "⏱️ Time Race: Try to beat your fastest time",
      "🏆 Score Tracking: Save your best times",
      "🎯 Easy to learn, hard to master",
      "📱 Built with Swift & UIKit"
    ]
  }
};

const screenshots = [
  screenshot1,
  screenshot2,
  screenshot3,
  screenshot4,
  screenshot5,
  screenshot6,
  screenshot7
];

function OneToFiftyCard({ imgPath }) {
  const [language, setLanguage] = useState("tr");
  const [showModal, setShowModal] = useState(false);
  const content = translations[language];

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={imgPath} alt="card-img" />
        <Card.Body>
          <div style={{ marginBottom: "15px" }}>
            <ButtonGroup size="sm">
              <Button
                variant={language === "tr" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("tr")}
              >
                TR
              </Button>
              <Button
                variant={language === "en" ? "primary" : "outline-primary"}
                onClick={() => setLanguage("en")}
              >
                EN
              </Button>
            </ButtonGroup>
          </div>
          <Card.Title>{content.title}</Card.Title>
          <Card.Text style={{ textAlign: "justify" }}>
            {content.description}
          </Card.Text>
          <Button
            variant="primary"
            onClick={() => setShowModal(true)}
          >
            <AiOutlineInfoCircle /> &nbsp;
            {content.details}
          </Button>
          <Button
            variant="primary"
            href="https://apps.apple.com/us/app/1-to-50-race/id1447751286"
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <IoIosAppstore /> &nbsp;
            App Store
          </Button>
          <div style={{ marginTop: "10px" }}>
            <Button
              variant="outline-primary"
              as={Link}
              to="/privacy-policy"
              size="sm"
              style={{ marginRight: "5px" }}
            >
              {content.privacy}
            </Button>
            <Button
              variant="outline-primary"
              as={Link}
              to="/terms-of-service"
              size="sm"
            >
              {content.terms}
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton style={{ backgroundColor: "#1a1a2e", color: "white" }}>
          <Modal.Title>{content.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#16213e", color: "white" }}>
          <Carousel>
            {screenshots.map((screenshot, index) => (
              <Carousel.Item key={index}>
                <img
                  className="d-block w-100"
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                  style={{ maxHeight: "500px", objectFit: "contain" }}
                />
              </Carousel.Item>
            ))}
          </Carousel>

          <div style={{ marginTop: "20px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
              ✨ {content.modalTitle.split(" - ")[1]}
            </h5>
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {content.features.map((feature, index) => (
                <li key={index} style={{ marginBottom: "10px", fontSize: "16px" }}>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#1a1a2e", borderTop: "1px solid #c770f0" }}>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OneToFiftyCard;
